import {HomeEnum} from 'presentation/constants';
import {usePersonalData, usePrint} from 'presentation/hooks';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';
import {useCalendarEvent} from 'presentation/modules/booking/shared/hooks/useCalendarEvent';
import {useMediaQueries} from 'presentation/pages';
import {AppointmentsHomeStateType} from 'presentation/pages/private/home/types';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {getAddressforMaps} from 'presentation/utils';
import {useNavigate} from 'react-router-dom';

export function useExamConfirmationBookingContent(bookedAppointment: AppointmentsHomeStateType) {
	const {isMobile} = useMediaQueries();
	const {isPrinting, printContent, printRef, shareContent, isSharing} = usePrint();
	const calendarEvent = useCalendarEvent(bookedAppointment);
	const navigate = useNavigate();
	const {userName} = usePersonalData();
	const accountData = useAccountDataStore(state => state.accountData);

	const beneficiaryName = userName;
	const planName = accountData.beneficiary.nmPlano;

	const {
		clinicName,
		formattedAddress,
		hour,
		dateOnly,
		providerName,
		specialtyName,
		protocolNumber,
		specialtyCode,
	} = bookedAppointment;

	const address = getAddressforMaps(formattedAddress);
	const addressForMaps = address.addressForMaps || '';

	const handleOpenGoogleMaps = () => openGoogleMaps(addressForMaps);

	const goToHome = () => {
		navigate(HomeEnum.HOME_PAGE);
	};

	return {
		isMobile,
		isPrinting,
		isSharing,
		printContent,
		printRef,
		calendarEvent,
		date: dateOnly,
		hour,
		providerName,
		specialtyName,
		protocolNumber,
		beneficiaryName,
		planName,
		goToHome,
		shareContent,
		handleOpenGoogleMaps,
		formattedAddress,
		clinicName,
		specialtyCode,
		addressForMaps,
	};
}
